import { inject, bindable, IEventAggregator } from 'aurelia';

@inject(Element, IEventAggregator)
export class DeleteGroupItemCustomAttribute {
  @bindable({ primary: true }) group;
  @bindable index;
  @bindable reference;

  constructor(element, ea) {
    this.element = element;
    this.ea = ea;
    this.onClick = (event) => {
      event.preventDefault();
      this.ea.publish('remove-group-item', { groupName: this.group, groupIndex: this.index, referenceId: this.reference });
    };
  }

  attached() {
    this.element.addEventListener('click', this.onClick);
  }

  detaching() {
    this.element.removeEventListener('click', this.onClick);
  }
}
